// extracted by mini-css-extract-plugin
export default {"container":"PriceList_container__N884K","wrapper":"PriceList_wrapper__d+HX5","footerStyle":"PriceList_footerStyle__kZRFV"};